import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import updateQuoteLine from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdateQuoteLine";
import translate from "@insite/client-framework/Translate";
import { QuoteLineModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { ChangeEvent, useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    quote: QuoteModel;
    quoteLine: QuoteLineModel;
    extendedStyles?: QuoteCostCodeStyles;
}

const mapDispatchToProps = {
    updateQuoteLine,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface QuoteCostCodeStyles {
    costCodeLabelText?: TypographyPresentationProps;
    costCodeLabel?: TypographyPresentationProps;
    costCodeSelect?: SelectPresentationProps;
    costCodeText?: TypographyPresentationProps;
    costCodeGridItem?: GridItemProps;
}

export const quoteCostCodeStyles: QuoteCostCodeStyles = {
    costCodeLabelText: {
        css: css`
            font-weight: 400;
        `,
    },
    costCodeLabel: {
        css: css`
            font-weight: bold;
            margin-bottom: 10px;
        `,
    },
    costCodeGridItem: {
        width: 9,
        css: css`
            flex-direction: column;
        `,
    },
    costCodeSelect: {},
};

const styles = quoteCostCodeStyles;

const QuoteCostCode = ({ quote, quoteLine, extendedStyles, updateQuoteLine }: Props) => {
    const toasterContext = useContext(ToasterContext);
    const [costCode, setCostCode] = useState<string | undefined>(undefined);

    const handleSelect = (event: ChangeEvent<HTMLSelectElement>) => {
        const id = event.currentTarget.value;
        setCostCode(id);
        onCostCodeChange(id);
    };

    const onCostCodeChange = (costCode: string) => {
        if (costCode !== quoteLine.costCode) {
            updateQuoteLine({
                quoteId: quote.id,
                quoteLineId: quoteLine.id,
                quoteLine: {
                    ...quoteLine,
                    costCode,
                },

                onSuccess: () => {
                    toasterContext.addToast({
                        body: translate("Cost Code Updated"),
                        messageType: "success",
                    });
                },
            });
        }
    };
    const [styles] = React.useState(() => mergeToNew(quoteCostCodeStyles, extendedStyles));
    return (
        <GridContainer>
            <GridItem {...styles.costCodeGridItem}>
                {quote.showCostCode && (
                    <>
                        <Typography {...styles.costCodeLabel}>
                            {translate("Cost Code :")}
                            <Typography {...styles.costCodeLabelText}>{quote.costCodeLabel}</Typography>
                        </Typography>
                        {quote.canEditCostCode ? (
                            <Select {...styles.costCodeSelect} onChange={handleSelect} value={quoteLine.costCode}>
                                {quote.costCodes?.map(costCode => (
                                    <option key={costCode.costCode} value={costCode.costCode}>
                                        {costCode.description}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Typography {...styles.costCodeText}>{quoteLine.costCode}</Typography>
                        )}
                    </>
                )}
            </GridItem>
        </GridContainer>
    );
};
export default connect(null, mapDispatchToProps)(QuoteCostCode);
